import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=871e2962&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=871e2962&prod&lang=less&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=871e2962&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e2962",
  null
  
)

export default component.exports